import { render, staticRenderFns } from "./PengaturanKeamananView.vue?vue&type=template&id=feec38c0&scoped=true"
import script from "./PengaturanKeamananView.vue?vue&type=script&lang=js"
export * from "./PengaturanKeamananView.vue?vue&type=script&lang=js"
import style0 from "./PengaturanKeamananView.vue?vue&type=style&index=0&id=feec38c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feec38c0",
  null
  
)

export default component.exports